import { render, staticRenderFns } from "./CamerasFinder.vue?vue&type=template&id=670f643c"
import script from "./CamerasFinder.vue?vue&type=script&lang=js"
export * from "./CamerasFinder.vue?vue&type=script&lang=js"
import style0 from "./CamerasFinder.vue?vue&type=style&index=0&id=670f643c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports